import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteContract } from './types';

// The signed contract for a quote (null until an agreement exists). Powers the quote page's
// "Signed contract" card; the download url is presigned per request, so we always refetch.
export function useBillingQuoteContract(quoteId: string | null) {
  const { data, error, isLoading, mutate } =
    useSWR<TBillingQuoteContract | null>(
      quoteId ? `commenda-billing/quotes/${quoteId}/contract` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { contract: data ?? null, error, isLoading, mutate };
}
